export default __webpack_public_path__ + "static/Plots0012-34c8c6041e0917551b3086cb744e1207.jpg";